export default {"src":"/_next/static/media/MySQL.ac8626f4.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};